import authInterceptor from "../../AuthInterceptor";

export const UserManagementAPI = {
    getUserList: () =>
        authInterceptor.get(`accounts-api/list-user-api/`)
            .then((response) => response.data)
            .catch((error) => error.response),
    creatUserPost: (bodyData) =>
        authInterceptor.post(`accounts-api/create-user-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    deleteUserPost: (bodyData) =>
        authInterceptor.post(`accounts-api/delete-user-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    editUserPost: (bodyData) =>
        authInterceptor.post(`accounts-api/edit-user-api/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),
    regenerateTempPass: (bodyData) =>
        authInterceptor.post(`ranking-api/regenerate_temp_pswd/`, bodyData)
            .then((response) => response.data)
            .catch((error) => error.response),

}